/*
 * @Author: cgh
 * @Date: 2022-08-02 15:57:03
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-24 18:28:04
 * @Description: 报告管理
 */

const bgglRoutes = {
  path: 'bggl',
  name: 'jxxfPgBggl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'dscbg',
      name: 'jxxfPgdsc',
      component: () => import(/* webpackChunkName: "xfpgdsc" */ '@/features/jxxf/pg/bggl/list.vue'),
      meta: {
        navtabTitle: '待生成报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'dqz',
      name: 'jxxfPgdqz',
      component: () => import(/* webpackChunkName: "xfpgdqz" */ '@/features/jxxf/pg/bggl/list.vue'),
      meta: {
        navtabTitle: '历史待签章报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'yqz',
      name: 'jxxfPgyqz',
      component: () => import(/* webpackChunkName: "xfpgyqz" */ '@/features/jxxf/pg/bggl/list.vue'),
      meta: {
        navtabTitle: '已完成报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'sybg',
      name: 'jxxfPgsybg',
      component: () => import(/* webpackChunkName: "xfpgdgz" */ '@/features/jxxf/pg/bggl/list.vue'),
      meta: {
        navtabTitle: '所有报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false,
        menuElements: [
          { elementCode: 'jxxf_pg_report_search', elementName: '查询' },
          { elementCode: 'jxxf_pg_report_reevaluate', elementName: '重新评估' }
        ]
      }
    }
  ]
};

export default bgglRoutes;
